import { FC } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { LOGIN_ROUTE } from 'src/constants/routes'
import { useGetSelfQuery } from 'src/reactQuery/useGetSelfQuery'
import { Layout } from '../Layout'

interface PrivateRouteProps {
  requiresAdminAccess?: boolean
}

export const PrivateRoute: FC<PrivateRouteProps> = ({
  requiresAdminAccess = false,
}) => {
  const { data: userData, isLoading } = useGetSelfQuery()
  const location = useLocation()

  // Don't redirect to login while the session check is still in flight —
  // on a hard refresh data is undefined on first render, and bouncing to
  // /login here logged users out (or dumped them on HOME) whenever getSelf
  // was slow or flaky.
  if (isLoading) {
    return null
  }

  const isAuthenticated = requiresAdminAccess
    ? userData?.user?.role === 'admin'
    : userData && userData?.user !== null && userData?.user !== undefined

  return (
    <>
      {isAuthenticated ? (
        <Layout>
          <Outlet />
        </Layout>
      ) : (
        <Navigate state={{ from: location }} to={LOGIN_ROUTE} />
      )}
    </>
  )
}
